import gql from 'graphql-tag';

export const COMPANY_SLACK_CHANNELS_FROM_DB = gql`
  query companySlackChannelsFromDb(
    $search: String
    $page: Int
    $perPage: Int
    $slackTeamId: String
  ) {
    companySlackChannelsFromDb(
      search: $search
      page: $page
      perPage: $perPage
      slackTeamId: $slackTeamId
    ) {
      totalCount
      channels {
        channelId
        channelName
      }
      otherWorkspaceChannels {
        channelId
        channelName
        teamId
        slackTeamName
      }
      otherWorkspaceTotalCount
    }
  }
`;

export const CHECK_SLACK_CHANNEL_EXISTS = gql`
  query checkSlackChannelExists($channelName: String!) {
    checkSlackChannelExists(channelName: $channelName)
  }
`;
